import { UploadType } from "@common/enums/UploadType";
import { IDocument } from "@common/models/Document/IDocument";

export function removeDuplicateDocumentsUsingMap(docs: IDocument[]): IDocument[] {
    const docMap = new Map<string, IDocument>();
    docs.forEach((doc: any) => {
        if (doc.type !== UploadType.Folder) {
            const identifier = `${doc.documentId}-${doc.documentName}`;
            if (!docMap.has(identifier)) {
                docMap.set(identifier, doc);
            }
        }
    });
    return Array.from(docMap.values());
}
